import React from 'react'

/**
 * Returns the previous value of the given state variable.
 *
 * @template T
 * @param {T} value - state variable
 * @returns {T | undefined} - previous value of the given state variable
 *
 * @example
 * const [value, setValue] = useState(0)
 * const previousValue = usePrevious(value)
 */
export function usePrevious<T>(value: T): T | undefined {
  const [current, setCurrent] = React.useState<T>(value)
  const [previous, setPrevious] = React.useState<T>()

  if (value !== current) {
    setPrevious(current)
    setCurrent(value)
  }

  return previous
}
